<app-alert></app-alert>
<section class="card">
    <div>
        <div class="card-header">
            <span class="cat__core__title">
                <strong id="pageTitle">Register of Electronic Clearing Service (ECS)</strong>
            </span>
            <span style="float: right">
                <!-- <a routerLink="/ecslist"> -->
                    <button (click)="back()"  class="btn btn-sm btn-default pull-right btn-back" type="button">
                        <i class=" fa fa-chevron-circle-left"></i>
                        Back
                    </button>
                <!-- </a> -->
            </span>
<!--            
            <span style="float:right">
                <button class="btn btn-success pull-right" class="btn btn-sm btn-primary" style="margin-right: 8px;" (click)="generateOutput()" type="button" *ngIf="!addBtn">
                  <span>
                    <i class="fa fa-save"></i>Generate Output</span>
                </button>
          </span> -->
        </div>


        <form [formGroup]='ecsForm' (document:click)="a.close()">

            <div class="modal-body">
                <div class="row">
                    <section class="panel panel-default">
                        <div class="panel-heading">
                            <h5 class="panel-title">Bank Details</h5>
                        </div>
                        <div class="panel-body">
                            <div class="row ">
                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Name of the bank</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['nameofbank']" class="form-control">
                                        <div *ngIf="ecsForm.controls['nameofbank'].hasError('pattern') " class="form-control-error-custom">
                                            Should only include alphabhets
                                        </div>

                                        <div *ngIf="ecsForm.controls['nameofbank'].hasError('required') && ecsForm.controls['nameofbank'].touched" class="form-control-error-custom">
                                            Name of Bank is required
                                        </div>

                                    </div>

                                </div>

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Name of Branch</label>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['nameofbranch']" class="form-control">
                                        <div *ngIf="ecsForm.controls['nameofbranch'].hasError('pattern') && ecsForm.controls['nameofbranch'].touched" class="form-control-error-custom">
                                            Branch name is invalid
                                        </div>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Address of Bank</label>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['addressofbank']" class="form-control">
                                        <div *ngIf="ecsForm.controls['addressofbank'].hasError('pattern') && ecsForm.controls['addressofbranch'].touched" class="form-control-error-custom">
                                            Bank address is invalid
                                        </div>
                                    </div>
                                </div>


                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Type of Account</label>
                                    <span _ngcontent-c2="" style="color: red;">*</span>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['typeofaccount']" class="form-control">

                                        <div *ngIf="ecsForm.controls['typeofaccount'].hasError('required') && ecsForm.controls['typeofaccount'].touched" class="form-control-error-custom">
                                            Type of Account is required
                                        </div>
                                    </div>

                                </div>

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Bank Account Number</label>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['bankaccountnumber']" (keydown)="onlyNumber($event)" class="form-control">
                                        <div *ngIf="(ecsForm.controls['bankaccountnumber'].hasError('minlength') || ecsForm.controls['bankaccountnumber'].hasError('maxlength')) && ecsForm.controls['bankaccountnumber'].touched"
                                            class="form-control-error-custom">
                                            Bank Account Number is invalid.</div>
                                    </div>
                                </div>

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">IFSC Code</label>
                                    <div class="form-group">
                                        <input [formControl]="ecsForm.controls['ifsccode']" class="form-control">

                                    </div>
                                </div>


                            </div>
                        </div>
                    </section>



                  

                    <section class="panel panel-default">
                        <div class="panel-heading">
                            <h5 class="panel-title">Other Details</h5>
                        </div>
                        <div class="panel-body">
                            <div class="row ">

                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label>Date of BM in Which ECS Facility Adopted</label>
                                    <div class="input-group" (click)="$event.stopPropagation()">
                                        <input class="form-control" [formControl]="ecsForm.controls['dateOfBM']" [(ngModel)]="dateOfBMModel" style="padding:6px;z-index: 0;"
                                            placeholder="dd-mm-yyyy" name="dateOfBMModel" ngbDatepicker #a="ngbDatepicker" (click)="a.toggle();">
                                        <button class="input-group-addon" (click)="a.toggle();" type="button">
                                            <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                                        </button>
                                    </div>

                                </div>


                                <div class="col-md-4 col-sm-6 col-xs-12">
                                    <label class="form-control-label">Authorized Signatory with Designation</label>
                                    <div class="form-group">
                                        <select class="form-control" [formControl]="ecsForm.controls['authorizedsign']" style="padding:6px;">

                                            <option value="" [selected]="true">Select Authorized Type</option>
                                            <option value="Severally">Severally</option>
                                            <option value="Jointly">Jointly</option>
                                        </select>

                                    </div>
                                </div>
                                <!--dropdown div-->



                                <div class="col-md-4 col-sm-6 col-xs-12"><br>
                                    <label>Remarks, if any</label>
                                    <textarea class="form-control" [formControl]="ecsForm.controls['remarks']" maxlength="250"> </textarea>
                                </div>

                            </div>
                        </div>
                    </section>


                </div>

            </div>

            <!--model-->
            <div class="card-footer" align="right">

                <button class="btn btn-sm btn-primary" (click)="saveEcsData()" [disabled]="!ecsForm.valid || disabledOnclick" type="button" *ngIf="addBtn">Save</button>
                <!-- <button class="btn btn-sm btn-primary" (click)="generateOutput()" type="button" *ngIf="!addBtn">
                    <span>
                        <i class="fa fa-save"></i>Generate Output </span>
                </button> -->
                <button class="btn btn-sm btn-primary" (click)="updateBankAccountParticulars(ParticularId._id)" type="button" [disabled]="!ecsForm.valid || disabledOnclick "
                    *ngIf="!addBtn">Update</button>
            </div>

        </form>

    </div>


</section>